/**
 * Model for TournamentTab
 */
export default class TournamentTabModel {
  /**
   * class constructor method
   * @param data
   */
  constructor(data) {
    /**
     * Tournament Tab Name
     * @type {string}
     */
    this.tournamentTabName = data.ttn;
    /**
     * Tournament Tab  id
     * @type {number}
     */
    this.tournamentTabId = data.ttid;
    /**
     * Tournament Order
     * @type {number}
     */
    this.tournamentOrder = data.ord;
  }
}